import type { ScalarGuideElement } from '@/types'
import { validate } from '@/helpers/validate'
import { attributesFlexSchema, type AttributesFlex } from './attributes'
import { html } from '@/helpers/html-template'

export const scalarFlex: ScalarGuideElement<AttributesFlex, 'flex'> = {
  name: 'flex',
  tagName: 'flex',
  tiptapName: '',

  attributeTransform: (_, attributes) => {
    return validate(attributesFlexSchema, {
      row: Boolean(attributes.row),
      column: Boolean(attributes.column),
      grow: Number(attributes.grow),
      align: attributes.align as 'start' | 'center' | 'end',
      justify: attributes.justify as 'start' | 'center' | 'end',
    })
  },
  render: async () => {
    return html`
    <div class="flex">
      <ssg-children />
    </div>`
  },
}
